import $ from 'jquery';


const SET_LANG_ENDPOINT = '/i18n/setlang/';


export const setLanguage = function (code) {
    return $.post(SET_LANG_ENDPOINT, {
        language: code,
        csrfmiddlewaretoken: $('body').data('csrf')
    });
};



// WEBPACK FOOTER //
// ./assets/js/services/i18n.js